import moment from "moment-timezone";
import { Star } from "lucide-react";
import CurrentTime from "../../CurrentTime";
import { useScheduleContext } from "../../../../hooks/context/useScheduleContext";
import { useFilters } from "../../../../../../../utils/hooks/useFilters";
import { useGridDates } from "../../../../hooks/grid/useGridDates";
import { useHolidays } from "../../../../api/useHolidays";
import { cn } from "../../../../../../../lib/utils";

function DailyInfo({ cellWidth, currentTimeOffset }: any) {
    const { data } = useHolidays();
    const { gridDates } = useGridDates();
    const [{ mode, from }] = useFilters();
    const { showCurrentTime } = useScheduleContext();

    const isDayMode = mode === "day";

    const getHolidays = (date: string) =>
        data.filter((holiday: any) => holiday.dates.includes(date));

    if (isDayMode) {
        const dayHolidays = getHolidays(moment(from).format("YYYY-MM-DD"));

        return (
            <div
                className="tw-relative tw-flex tw-flex-wrap tw-gap-3 tw-px-3 tw-py-1.5 tw-text-sm tw-text-center tw-min-h-16 tw-h-auto tw-border-b tw-border-t tw-border-t-transparent"
                style={{ minWidth: `${gridDates.length * cellWidth}px` }}
            >
                {dayHolidays.map((holiday: any) => (
                    <div
                        key={holiday.id ?? holiday.name}
                        className="tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-amber-300 tw-bg-amber-50 tw-px-4 tw-py-2 tw-text-sm tw-text-amber-900 min-w-50"
                    >
                        <Star size={14} className="tw-shrink-0 tw-fill-amber-400 tw-text-amber-400" />
                        {holiday.name}
                    </div>
                ))}

                {showCurrentTime && (
                    <CurrentTime currentTimeOffset={currentTimeOffset} />
                )}
            </div>
        );
    }

    return (
        <>
            {gridDates.map((day) => {
                const dayHolidays = getHolidays(day);
                const isToday = showCurrentTime && moment().isSame(day, "day");

                return (
                    <div
                        key={day}
                        className={cn(
                            "day-header tw-min-h-16 tw-border-t tw-border-t-transparent tw-flex-col tw-items-center tw-justify-center tw-gap-1",
                            isToday && "tw-bg-primary/5"
                        )}
                        style={{
                            minWidth: cellWidth,
                            maxWidth: cellWidth,
                            position: "relative",
                        }}
                    >
                        {dayHolidays.map((holiday: any) => (
                            <div
                                key={holiday.id ?? holiday.name}
                                className="tw-flex tw-items-center tw-gap-1.5 tw-rounded-md tw-border tw-border-amber-300 tw-bg-amber-50 tw-px-2 tw-py-1 tw-text-xs tw-text-amber-900 tw-w-[calc(100%-16px)]"
                            >
                                <Star size={10} className="tw-shrink-0 tw-fill-amber-400 tw-text-amber-400" />
                                <span className="tw-truncate">{holiday.name}</span>
                            </div>
                        ))}
                    </div>
                );
            })}
        </>
    );
}

export default DailyInfo;
